import { Clock, MapPin, Navigation } from "lucide-react";
import {
  BUSINESS,
  GOOGLE_HOURS,
  MAPS_DIRECTIONS_URL,
  MAPS_EMBED_URL,
} from "@/lib/business";

export const LocationSection = () => (
  <section
    id="localizacao"
    data-testid="location-section"
    className="scroll-mt-24 bg-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div data-reveal>
          <p
            data-testid="location-overline"
            className="text-xs font-bold uppercase tracking-[0.2em] text-brand"
          >
            Onde Estamos
          </p>
          <h2
            data-testid="location-heading"
            className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-stone-900"
          >
            Visite nossa loja em Mogi Guaçu
          </h2>
          <div className="mt-8 flex items-start gap-4 rounded-2xl border border-stone-200 bg-stone-50 p-6">
            <span className="inline-flex items-center justify-center w-12 h-12 shrink-0 rounded-full bg-brand-light text-brand">
              <MapPin className="w-6 h-6" />
            </span>
            <div>
              <p
                data-testid="location-address"
                className="text-base sm:text-lg font-semibold text-stone-900"
              >
                {BUSINESS.address}
              </p>
              <p className="mt-1 text-sm text-stone-500">
                Estamos te esperando. Em caso de dúvida, chame no WhatsApp.
              </p>
            </div>
          </div>
          <div
            data-testid="location-hours"
            className="mt-4 rounded-2xl border border-stone-200 bg-white p-6"
          >
            <p className="flex items-center gap-2 text-base font-semibold text-stone-900">
              <Clock className="w-5 h-5 text-brand" />
              Horário de funcionamento
            </p>
            <ul className="mt-3 space-y-1.5">
              {GOOGLE_HOURS.map((item) => (
                <li
                  key={item.days}
                  className="flex items-center justify-between gap-4 text-sm"
                >
                  <span className="text-stone-500">{item.days}</span>
                  <span className="font-medium text-stone-900">
                    {item.time}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-3 text-xs text-stone-400">
              Horários conforme o perfil da loja no Google.
            </p>
          </div>
          <a
            href={MAPS_DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="directions-button"
            className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-base font-semibold text-white shadow-md hover:bg-brand-dark hover:shadow-lg btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
          >
            <Navigation className="w-5 h-5" />
            Como chegar
          </a>
        </div>

        <div
          data-testid="map-container"
          data-reveal
          style={{ transitionDelay: "150ms" }}
          className="rounded-2xl overflow-hidden border border-stone-200 shadow-md"
        >
          <iframe
            title="Mapa com a localização da Ótica Danko em Mogi Guaçu"
            src={MAPS_EMBED_URL}
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  </section>
);
